<template>
  <div id="app">
    <a href="https://wa.me/5491170607500?" class="whatsapp-float" target="_blank" rel="noopener noreferrer">
      <i class="bi bi-whatsapp"></i>
    </a>
    <Loader/>
    <menuDesktop v-if="isDesktop" />
    <menuMobile v-else />
    <router-view></router-view>
  </div>
</template>

<script>
import Loader from './components/Loader.vue';
import menuDesktop from './components/menu/menuDesktop.vue';
import menuMobile from './components/menu/menuMobile.vue';

export default {
  name: 'App',
  components: {
    menuDesktop,
    menuMobile,
    Loader
  },
  data() {
    return {
      isDesktop: window.innerWidth >= 992
    }
  },
  mounted() {
  },
  methods: {
    changeLanguage() {
      // Lógica para cambiar el idioma
    }
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
  scroll-padding-top: 110px;
}
#app {
  font-family: Rubik, Helvetica, Arial, sans-serif;
}
.mobile-menu {
  height: 100% !important;
}

h1, h2, h3, h4, h5, h6 {
  color: #2C2C2C; 
  font-weight: bold !important;
}

p {
  color: #4A4A4A; 
}
</style>

<style scoped>
.whatsapp-float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 100;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.whatsapp-float i {
  width: 100%;
  height: auto;
  padding: 10px;
  vertical-align: text-top !important;
}

.whatsapp-float:hover {
  background-color: #1ebe5d;
  transform: scale(1.1);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
</style>
